import React, { useState } from "react"

function ExecutionReport({ fileName: propsFileName, date: propsDate, fileId: propsFileId } = {}) {
  const reportData = {
    fileName: propsFileName ?? "test.report",
    date: propsDate ?? "12/10/2025, 11:25:30 AM",
    fileId: propsFileId ?? 420,
  }

  const [previewDrawerOpen, setPreviewDrawerOpen] = useState(false)

  const handleDownload = () => {
    // Handle download action
    console.log("Download execution report")
  }

  const handleView = () => {
    setPreviewDrawerOpen(true)
  }

  return (
    <div id="execution-report-wrapper" className="w-full mb-2 px-6 py-4 bg-white dark:bg-gray-900 rounded-md">
      <div id="execution-report-container" className="w-full">
        <div id="execution-report-content" className="relative">
          <div id="execution-report-header" className="mb-2">
            <h2 className="font-semibold text-md text-gray-900 dark:text-gray-100">Execution Report</h2>
          </div>
          <div id="execution-report-body" className="flex flex-col w-full text-center items-center">
            <div id="execution-report-file-info" className="relative w-full">
              <div id="execution-report-file-display" className="flex select-none w-full rounded-md bg-gray-100 dark:bg-gray-800 dark:bg-gray-900 rounded-lg">
                <div id="execution-report-file-icon-container" className="p-1">
                  <div
                    id="execution-report-file-icon"
                    className="flex flex-col overflow-hidden shadow-md transition-all duration-200 hover:shadow-lg"
                    style={{ width: "30px", height: "auto", borderRadius: "6px" }}
                  >
                    <div
                      id="execution-report-icon-top"
                      className="flex items-center justify-center w-full bg-white dark:bg-gray-900"
                      style={{
                        height: "24px",
                        padding: "3px",
                        backgroundColor: "rgb(222, 222, 222)"
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#8C929D"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-file bg-transparent"
                      >
                        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                        <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                      </svg>
                    </div>
                    <div
                      id="execution-report-icon-label"
                      className="w-full flex items-center justify-center"
                      style={{
                        height: "12px",
                        backgroundColor: "rgb(140, 146, 157)"
                      }}
                    >
                      <span
                        id="execution-report-label-text"
                        className="text-center font-medium"
                        style={{
                          color: "rgb(232, 232, 232)",
                          width: "100%",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "6.75px"
                        }}
                      >
                        REPO
                      </span>
                    </div>
                  </div>
                </div>
                <div id="execution-report-file-details" className="flex flex-col justify-center text-left ml-2">
                  <p id="execution-report-file-name" className="text-sm font-medium text-gray-800">
                    {reportData.fileName}
                  </p>
                  <p id="execution-report-file-date" className="text-xs text-gray-500">
                    {reportData.date}
                  </p>
                </div>
                <div id="execution-report-file-actions" className="flex-grow flex justify-end items-center pr-2">
                  <div id="execution-report-download-action" className="mr-2">
                    <div
                      id="execution-report-download-button"
                      className="cursor-pointer flex justify-between relative rounded-md overflow-hidden group relative hover:bg-gradient-to-r hover:from-gray-200 hover:to-gray-50 hover:ring-2 hover:ring-offset-2 hover:ring-gray-600 transition-all ease-out duration-300 cursor-pointer hover:bg-gray-200 dark:bg-gray-800 text-gray-500 p-2 rounded-md w-full"
                      onClick={handleDownload}
                    >
                      <span className="absolute right-0 w-8 h-32 -mt-12 transition-all duration-500 transform translate-x-12 bg-gray-400 opacity-10 rotate-12 group-hover:-translate-x-40 ease"></span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-download h-5 w-5"
                      >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="7 10 12 15 17 10"></polyline>
                        <line x1="12" x2="12" y1="15" y2="3"></line>
                      </svg>
                    </div>
                  </div>
                  <div id="execution-report-view-action" className="mr-2">
                    <div
                      id="execution-report-view-button"
                      className="cursor-pointer flex justify-between relative rounded-md overflow-hidden group relative hover:bg-gradient-to-r hover:from-gray-200 hover:to-gray-50 hover:ring-2 hover:ring-offset-2 hover:ring-gray-600 transition-all ease-out duration-300 cursor-pointer hover:bg-gray-200 dark:bg-gray-800 text-gray-500 p-2 rounded-md w-full"
                      onClick={handleView}
                    >
                      <span className="absolute right-0 w-8 h-32 -mt-12 transition-all duration-500 transform translate-x-12 bg-gray-400 opacity-10 rotate-12 group-hover:-translate-x-40 ease"></span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-eye h-5 w-5"
                      >
                        <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                    </div>
                  </div>
                  <a id="execution-report-folder-link" href={`/file/${reportData.fileId}`} className="mr-2">
                    <div
                      id="execution-report-folder-button"
                      className="cursor-pointer flex justify-between relative rounded-md overflow-hidden group relative hover:bg-gradient-to-r hover:from-gray-200 hover:to-gray-50 hover:ring-2 hover:ring-offset-2 hover:ring-gray-600 transition-all ease-out duration-300 hover:bg-gray-200 dark:bg-gray-800 text-gray-500 p-2 rounded-md w-full"
                    >
                      <span className="absolute right-0 w-8 h-32 -mt-12 transition-all duration-500 transform translate-x-12 bg-gray-400 opacity-10 rotate-12 group-hover:-translate-x-40 ease"></span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-folder-symlink h-5 w-5"
                      >
                        <path d="M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7"></path>
                        <path d="m8 16 3-3-3-3"></path>
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Left-side preview drawer */}
      {previewDrawerOpen && (
        <>
          <div
            id="execution-report-preview-backdrop"
            role="presentation"
            aria-hidden="true"
            className="fixed inset-0 z-[230] bg-black/40"
            onClick={() => setPreviewDrawerOpen(false)}
          />
          <div
            id="execution-report-preview-drawer"
            className="fixed top-0 right-0 bottom-0 z-[240] flex h-[100dvh] max-h-[100dvh] flex-col overflow-hidden bg-white dark:bg-gray-900 border border-gray-200 rounded-l-md shadow-xl"
            style={{
              width: "min(28rem, 85vw)",
              minWidth: "260px",
              transform: previewDrawerOpen ? "translateX(0)" : "translateX(100%)",
              transition: "transform 0.3s ease-in-out",
            }}
          >
            <div className="flex-shrink-0 flex items-center justify-between gap-2 px-4 py-3 border-b border-gray-200">
              <h3 id="execution-report-preview-title" className="font-semibold text-gray-900 dark:text-gray-100 truncate">
                {reportData.fileName}
              </h3>
              <button
                id="execution-report-preview-close"
                type="button"
                onClick={() => setPreviewDrawerOpen(false)}
                className="p-2 rounded-md text-gray-500 hover:bg-gray-100 dark:bg-gray-800 dark:bg-gray-900 hover:text-gray-700 dark:text-gray-300 transition-colors"
                aria-label="Close preview"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 6L6 18" />
                  <path d="M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="flex-1 min-h-0 overflow-hidden bg-gray-50 dark:bg-gray-950 dark:bg-gray-950">
              <iframe
                id="execution-report-preview-iframe"
                title={`Preview: ${reportData.fileName}`}
                src={`/file/${reportData.fileId}`}
                className="w-full h-full border-0"
              />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default ExecutionReport

